<template>
  <div class="helper text-center primary" style="z-index: 99999 !important;">
    <v-menu
        v-model="menu"
        :close-on-content-click="false"
        left
        tile
        offset-x
        nudge-left="15"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          size="28"
          color="white"
          v-bind="attrs"
          v-on="on"
        >
          mdi-cog
        </v-icon>
      </template>

      <v-card class="helper-card px-0">
        <v-list>
          <v-list-item>

            <v-list-item-content>
              <v-list-item-title class="text-center">Color Theme</v-list-item-title>
            </v-list-item-content>

          </v-list-item>
          <v-list-item>
            <v-list-item-action class="justify-center mr-0" style="width: 100%">
              <v-radio-group v-model="radios">
                <v-radio color="primary" value="radio-1" class="mb-0 mr-5" @click="mainTheme(), almacenarTema()"></v-radio>
                <v-radio color="secondary" value="radio-2" class="mb-0 mr-5" @click="secondTheme(),almacenarTema()"></v-radio>
                <v-radio color="success" value="radio-3" class="mb-0" @click="thirdTheme(),almacenarTema()"></v-radio>
              </v-radio-group>
            </v-list-item-action>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="text-center">Dark Mode</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-action class="justify-center mr-0" style="width: 100%">
              <v-switch v-model="switcher" @change="almacenarTema()" color="secondary"></v-switch>
            </v-list-item-action>
          </v-list-item>
        </v-list>
        <v-card-actions>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
  import config from '@/config.js';
  import { mapActions } from 'vuex'
  import LocalStorage  from '@/utils/managerLocalStorage.js';

export default {
  name: 'Helper',
  data: () => ({
    fav: true,
    menu: false,
    message: false,
    hints: true,
    config,
    radios: 'radio-1',
    mode: false,
    switcher: false,
    local: ''
  }),

  methods: {
    ...mapActions([ 'TOGGLE_THEME' ]),
    mainTheme() {
      // if (this.$vuetify.theme.dark) {
      //   this.TOGGLE_THEME(this.switcher)
      //   this.$vuetify.theme.dark = false
      //   this.$vuetify.theme.themes.light.primary = config.light.primary
      //   this.switcher = false
      // } else {
        this.$vuetify.theme.themes.light.primary = this.config.light.primary
      // }
    },
    secondTheme() {
      // if (this.$vuetify.theme.dark) {
      //   this.TOGGLE_THEME(this.switcher)
      //   this.$vuetify.theme.dark = false
      //   this.$vuetify.theme.themes.light.primary = config.light.secondary
      //   this.switcher = false
      // } else {
        this.$vuetify.theme.themes.light.primary = this.config.light.secondary
      // }
    },
    thirdTheme() {
    //   if (this.$vuetify.theme.dark) {
    //     this.TOGGLE_THEME(this.switcher)
    //     this.$vuetify.theme.dark = false
    //     this.$vuetify.theme.themes.light.primary = config.light.success
    //     this.switcher = false
    //   } else {
        this.$vuetify.theme.themes.light.primary = this.config.light.success
      // }
    },
    almacenarTema(){
      LocalStorage.addSingleLocalStorageFree(
        {nocturno: this.switcher, tema: this.radios}, "tema"
      );
    }
  },
  
  watch: {
    switcher(newValue) {
      this.TOGGLE_THEME(this.switcher)
      this.$vuetify.theme.dark = newValue
    }
  },
  created() {
      this.local = LocalStorage.getSingleValueInLocalStorage("tema");
  },
  mounted() {
    if(this.local != ''){
      this.TOGGLE_THEME(this.local.nocturno)
      this.$vuetify.theme.dark = this.local.nocturno;
      this.switcher = this.local.nocturno;
      this.radios = this.local.tema;
      switch (this.local.tema) {
        case 'radio-1':
          this.mainTheme();
          break;
        case 'radio-2':
          this.secondTheme();
          break;
        default:
          this.thirdTheme();
          break;
      }
    }
  },
};
</script>

<style src="@/views/shared/helper/Helper.scss" lang="scss"></style>
